/**
 * decompose · «разбери артефакт на тест-кейсы» click-to-reveal counter (S04 TD-05).
 *
 * Topic-fit practice for Use Case structure: the student taps each flow / branch
 * of a real Use Case and sees which Test Case it spawns, while two counters climb
 * — total TC and (separately) negative TC. Drives home the ticket's core message
 * (AC-03/04): one UC unfolds into 10+ TC and every Alternate Flow is a ready-made
 * negative scenario — no grooming with PM. Replaces the old static `details` list.
 *
 * Markup contract (authored content · no-JS degradable — without this script every
 * `.ucd-tc` shows inline as a readable mapping list):
 *   <div class="ucd">
 *     <div class="ucd-head"><span class="ttl">Разбери UC на тест-кейсы</span>
 *       <span class="ucd-counters"><span class="ucd-cnt">TC: <b class="ucd-total">0</b>/13</span>
 *         <span class="ucd-cnt neg">негатив: <b class="ucd-neg">0</b></span></span></div>
 *     <div class="ucd-intro">…</div>
 *     <div class="ucd-list">
 *       <div class="ucd-row" data-neg="0">
 *         <span class="ucd-tag main">Main</span>
 *         <span class="ucd-mid"><span class="ucd-src">…строка UC…</span>
 *           <span class="ucd-tc">→ <b>TC-001</b> …</span></span>
 *         <span class="ucd-pick">+</span></div>
 *       … rows · data-neg="1" marks a negative TC; .ucd-tag main|alt|post …
 *     </div>
 *     <div class="ucd-fin">…payoff (revealed on completion)…</div>
 *   </div>
 */

export function initDecompose(root: HTMLElement): () => void {
  if (typeof document === 'undefined') return () => {};
  const cleanups: Array<() => void> = [];

  const decks = Array.from(root.querySelectorAll<HTMLElement>('.ucd'));
  for (const ucd of decks) {
    if (ucd.dataset.ucdInit === '1') continue;
    ucd.dataset.ucdInit = '1';
    ucd.classList.add('ucd-ready');

    const rows = Array.from(ucd.querySelectorAll<HTMLElement>('.ucd-row'));
    const totalEl = ucd.querySelector<HTMLElement>('.ucd-total');
    const negEl = ucd.querySelector<HTMLElement>('.ucd-neg');
    const fin = ucd.querySelector<HTMLElement>('.ucd-fin');
    if (rows.length === 0) continue;

    let total = 0;
    let neg = 0;

    for (const row of rows) {
      const onPick = () => {
        if (row.classList.contains('done')) return;
        row.classList.add('done');
        const pick = row.querySelector<HTMLElement>('.ucd-pick');
        if (pick) pick.textContent = '✓';
        total += 1;
        if (row.dataset.neg === '1') neg += 1;
        if (totalEl) totalEl.textContent = String(total);
        if (negEl) negEl.textContent = String(neg);
        if (total === rows.length && fin) fin.classList.add('on');
      };
      row.addEventListener('click', onPick);
      cleanups.push(() => row.removeEventListener('click', onPick));
    }

    // StrictMode (dev) double-invoke safety (see scDeck.ts).
    cleanups.push(() => {
      ucd.classList.remove('ucd-ready');
      delete ucd.dataset.ucdInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
